import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4aa28a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "prototype-machine-wrapper" }

import { defineComponent, ref, provide } from "vue";
import prototypeTable from "./table.vue";
import statistics from "./statistics.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const activeKey = ref("trialPrototype");
provide("activeKey", activeKey);

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      type: "card",
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, {
          key: "trialPrototype",
          tab: "试用样机"
        }, {
          default: _withCtx(() => [
            (activeKey.value === 'trialPrototype')
              ? (_openBlock(), _createBlock(prototypeTable, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "trialEnds",
          tab: "试用结束"
        }, {
          default: _withCtx(() => [
            (activeKey.value === 'trialEnds')
              ? (_openBlock(), _createBlock(prototypeTable, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "prototypeForSale",
          tab: "样机转销售"
        }, {
          default: _withCtx(() => [
            (activeKey.value === 'prototypeForSale')
              ? (_openBlock(), _createBlock(prototypeTable, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, {
          key: "statistics",
          tab: "使用统计"
        }, {
          default: _withCtx(() => [
            (activeKey.value === 'statistics')
              ? (_openBlock(), _createBlock(statistics, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["activeKey"])
  ]))
}
}

})